(function($) {
	formHelper.addRule({
		form: '.mwr-base-membership-commission-form',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			}
		}
	});
})(jQuery);


jQuery(function initToolsMwrBaseMembershipCommissionReport($) {
	$('.search-base-membership-commission-form, .search-mwr-base-membership-commission-results-form').each(function(index, el) {

		var $container = $(this);

		// Date confirmation Range
		// ------------------
		var $memExpDateStart = $('#membership-expiration-start-date').pickadate({
			selectYears: 10,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var memExpDateStartPicker = $memExpDateStart.pickadate('picker');

		var $memExpDateEnd = $('#membership-expiration-end-date').pickadate({
			selectYears: 10,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var memExpDateEndPicker = $memExpDateEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( memExpDateStartPicker.get('value') ) {
			memExpDateEndPicker.set('min', memExpDateStartPicker.get('select'));
		}
		
		if ( memExpDateEndPicker.get('value') ) {
			memExpDateStartPicker.set('max', memExpDateEndPicker.get('select'));
		}

		// When something is selected, update the "memExpDateStart" and "memExpDateEnd" limits.
		memExpDateStartPicker.on('set', function(event) {
			if ( event.select ) {
				memExpDateEndPicker.set('min', memExpDateStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				memExpDateEndPicker.set('min', false);
			}
		});

		memExpDateEndPicker.on('set', function(event) {
			if ( event.select ) {
				memExpDateStartPicker.set('max', memExpDateEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				memExpDateStartPicker.set('max', false);
			}
		});
	});
});

jQuery(function initToolsMWRBaseMembershipCommissionResults($) {
	$('.search-mwr-base-membership-commission-results-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-search-mwr-base-membership-commission-report-results');
		var $pagesContainer        = $container.find('.tools-pages');
		var numPages               = $pagesContainer.data('pages');
		var currentPage            = $pagesContainer.data('start-page');

		for(var i = 1; i <= parseInt(numPages,10); i++) {
			if (i === parseInt(currentPage,10)) {
				currentClassCheck = " current";
			} else {
				currentClassCheck = '';
			}

			$pagesContainer.append('<div class="page' + currentClassCheck + '" data-page="' + i + '">' + i + '</div>');
		}

		// Bind all new page elements with page click function
		$(".page").click(function() {
			$('#filter-page').val($(this).data('page'));
			$form.submit();
		});

		// Bind refresh button
		$(".filter-refresh").click(function() {
			$('#filter-page').val(currentPage);
			$form.submit();
		});
	});
});